/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateTime/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function DateTime({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Status/Content/Content/DateTime"
  
}) {
let statusCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'status',
path: 'created_at',
format: fromFormat.dateISOToTime,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 marginLeft={4}
 data="status.created_at"
 format="/Data/format.js dateISOToTime"
 text={statusCreatedAtValueData}
/>
{children}
</React.Fragment>)
}